var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { customGradeAttributeStore } from '../stores/CustomGradeAttributeStore';
export default class GradeResult {
    rawValue;
    customGradeCode;
    gradeAttribute;
    constructor({ value, customGradeCode }) {
        this.rawValue = value;
        this.customGradeCode = customGradeCode;
        const gradeAttribute = customGradeAttributeStore.attributes[this.customGradeCode];
        if (!gradeAttribute) {
            customGradeAttributeStore.fetchItem(this.customGradeCode)?.then((gradeAttribute) => {
                this.gradeAttribute = gradeAttribute;
                this.setDefaultRawValue();
            });
        }
        else {
            this.gradeAttribute = gradeAttribute;
            this.setDefaultRawValue();
        }
    }
    get title() {
        return this.value?.title;
    }
    get value() {
        if (!this.gradeAttribute || !this.gradeAttribute.dict) {
            return null;
        }
        return this.gradeAttribute.dict.find((d) => d.id === this.rawValue);
    }
    setDefaultRawValue = () => {
        if (!this.rawValue) {
            this.rawValue = this.gradeAttribute.dict[Math.ceil(this.gradeAttribute.dict.length / 2)].id;
        }
    };
}
__decorate([
    observable
], GradeResult.prototype, "rawValue", void 0);
__decorate([
    observable
], GradeResult.prototype, "customGradeCode", void 0);
__decorate([
    observable
], GradeResult.prototype, "gradeAttribute", void 0);
__decorate([
    computed
], GradeResult.prototype, "title", null);
__decorate([
    computed
], GradeResult.prototype, "value", null);
__decorate([
    action
], GradeResult.prototype, "setDefaultRawValue", void 0);
